import {request} from "api-v3/request";

export const getSchoolRank = queryParams => {
  return request.get({
    path: "/engine/techlympic/schoolRank",
    queryParams,
  });
};

export const getSchoolRankList = queryParams => {
  return request.get({
    path: "/engine/techlympic/schoolRankList",
    queryParams,
  });
};

export const createRank = params => {
  return request.post({
    path: "/engine/techlympic/userRank",
    params,
  });
};
